export default "/_next/static/images/magic-line-top-3050439809ef8105466b589664894e43.png";